import gql from 'graphql-tag';

const ACCOUNT_UPDATE_SUBSCRIPTION = gql`
  subscription accountUpdates($id: String!){
    accountUpdates(id: $id) {
      id
    }
  }
`;

export default ACCOUNT_UPDATE_SUBSCRIPTION;



// WEBPACK FOOTER //
// ./src/graphql/subscriptions/accountupdate.subscription.js